import { GlobalOutlined } from "@ant-design/icons";
import { Avatar, Button, Flex, Select, Typography, theme } from "antd";
import { ECountryCode } from "../../models/countries.enum";
import { ELanguage } from "../../models/languages.enum";
import { deepCopy } from "../../utils/deepCopy";
const { Text, Title, Link } = Typography;
const { useToken } = theme;

export function AccountSetupLanguage({
  steps,
  currentStep,
  setCurrentStep,
  metadata,
  setMetadata,
}: {
  steps: number;
  currentStep: number;
  setCurrentStep: (data: number) => void;

  metadata: { [key: string]: any };
  setMetadata: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
}) {
  const { token } = useToken();

  return (
    <Flex
      style={{
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Flex
        style={{
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "320px",
        }}
      >
        <Avatar shape="square" size={64} icon={<GlobalOutlined />} />

        <Text
          style={{
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            marginBottom: token.marginMD,
            fontSize: token.fontSizeHeading3,
            marginTop: "10px",
            textAlign: "center",
          }}
        >
          Pick your language and country region
        </Text>

        {/* Content */}

        <Select
          style={{ width: "100%" }}
          showSearch
          placeholder="Select a language"
          optionFilterProp="label"
          value={metadata.language}
          onSelect={(value) => {
            setMetadata((prevState) => {
              const copy = deepCopy(prevState);

              copy.language = value;

              return copy;
            });
          }}
          options={Object.keys(ELanguage).map((key) => {
            return {
              value: (ELanguage as any)[key],
              label: key,
            };
          })}
        />

        <Select
          style={{ width: "100%", marginTop: token.marginMD }}
          showSearch
          placeholder="Select a country"
          optionFilterProp="label"
          value={metadata.country}
          onSelect={(value) => {
            setMetadata((prevState) => {
              const copy = deepCopy(prevState);

              copy.country = value;

              return copy;
            });
          }}
          options={Object.keys(ECountryCode).map((key) => {
            return {
              value: (ECountryCode as any)[key],
              label: key[0].toUpperCase() + key.slice(1).toLowerCase(),
            };
          })}
        />

        {/* EndContent */}

        <Button
          style={{
            margin: token.marginMD,
            padding: token.paddingContentVerticalLG,
            width: "320px",
            marginTop: token.marginXXL + token.marginXL,
          }}
          type="primary"
          onClick={() => {
            setCurrentStep(currentStep + 1);
          }}
        >
          <Text style={{ color: token.Button?.primaryColor }}>Next</Text>
        </Button>

        <Flex align="center" justify="space-between" style={{ width: "100%" }}>
          {/* <Button
            type="link"
            style={{ padding: 0 }}
            onClick={() => {
              setCurrentStep(currentStep + 1);
            }}
          >
            <Text style={{ textAlign: "left" }}>Skip</Text>
          </Button> */}
          <div />

          <Flex align="center">
            {Array.from({ length: steps }).map((_, index) => {
              if (index > currentStep) {
                return (
                  <Button
                    key={index}
                    size="small"
                    style={{
                      background: "transparent",
                      border: "none",
                      boxShadow: "none",
                    }}
                    onClick={() => setCurrentStep(index)}
                  >
                    <div
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: token.colorBgContainer,
                        border: `1px solid ${token.colorSplit}`,
                      }}
                    />
                  </Button>
                );
              }

              return (
                <Button
                  key={index}
                  size="small"
                  style={{
                    background: "transparent",
                    border: "none",
                    boxShadow: "none",
                  }}
                  onClick={() => setCurrentStep(index)}
                >
                  <div
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: token.colorPrimary,
                    }}
                  />
                </Button>
              );
            })}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
